import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { IClass, IClassResponse, IPartnerParams } from 'app/shared/models/partner-activity.model';
import { LoginTokenWithClassModel } from 'app/teacher/models/login-token-with-class.model';
import { RegisterMathologyDataModel } from 'app/teacher/models/register-mathology-data.model';
import { TeacherDataService } from 'app/teacher/services/teacher-data.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerActivityApiService {
  private http = inject(HttpClient);
  private readonly urlService = inject(UrlService);
  private readonly teacherDataService = inject(TeacherDataService);

  public getClasses(): Observable<IClassResponse> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'ExploreActivities');
    return this.http.get<IClassResponse>(url);
  }

  public createClass(params: Params): Observable<IClass> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'ExploreActivities');
    return this.http.post<IClass>(url, {
      CourseId: params.CourseId,
      CountryCode: params.CountryCode,
      RegionCode: params.RegionCode
    });
  }

  public partnerTokenResponse(partnerData: IPartnerParams, partner: string): Observable<LoginTokenWithClassModel> {
    const data: RegisterMathologyDataModel = {
      CourseId: partnerData.CourseId,
      CountryCode: partnerData.CountryCode,
      RegionCode: partnerData.RegionCode,
      PartnerId: partner
    };

    return this.teacherDataService.registerForMathology(data);
  }
}
